/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */

import { Action, NgxsOnInit, Selector, State, StateContext, Store } from '@ngxs/store';
import { PageStateModel } from './page.model';
import { AuthState } from '../../security/state/auth.state';
import { filter, tap } from 'rxjs/operators';
import { LoadPages } from './page.actions';
import { RestService } from '../../../modules/shared/services/rest.service';
import { Injectable } from '@angular/core';

@State<PageStateModel>({
    name: 'page',
    defaults: {
        loaded: false,
        defaultPage: 'map',
        enabledPages: [ 'dashboard', 'map' ]
    }
})
@Injectable()
export class PageState implements NgxsOnInit {
    constructor(private rest: RestService, private store: Store) {}

    ngxsOnInit(ctx?: StateContext<any>): any {
        this.store
            .select(AuthState.validated)
            .pipe(
                filter((b) => b),
                tap(() => setTimeout(() => ctx.dispatch(new LoadPages()), 0))
            ).subscribe();
    }

    @Action(LoadPages)
    loadPages({ patchState }: StateContext<PageStateModel>) {
        return this.rest.apiGet<PageStateModel>('pages').pipe(
            tap((data) => patchState(data)),
            tap(() => patchState({ loaded: true }))
        );
    }

    @Selector()
    static loaded(state: PageStateModel) {
        return state.loaded;
    }

    @Selector()
    static defaultPage(state: PageStateModel) {
        return state.defaultPage;
    }

    @Selector()
    static enabledPages(state: PageStateModel) {
        return state.enabledPages;
    }

    @Selector()
    static pageEnabled(state: PageStateModel) {
        return (page: string) => state.enabledPages.findIndex((p) => p === page) !== -1;
    }

    @Selector()
    static mapEnabled(state: PageStateModel) {
        return state.enabledPages.findIndex((p) => p === 'map') !== -1;
    }
}
